import { FC } from 'react'
import styled from '@emotion/styled'

const Button = styled.button<{
  bg: 'green' | 'red'
}>`
  display: flex;
  padding: 26px 180px;
  justify-content: center;
  align-items: center;
  gap: 26px;
  flex-shrink: 0;
  border-radius: 100px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  background: ${({ bg }) => (bg === 'green' ? 'rgba(22, 177, 84, 0.5);' : 'rgba(177, 22, 28, 0.50);')};
  color: #fff;
  text-align: center;

  /* Bigest Button */
  font-size: 50px;
  font-style: normal;
  font-weight: 510;
  line-height: normal;

  cursor: pointer;
`

type TRpDealerButtonProps = {
  text: string
  bg?: 'green' | 'red'
  cb?: () => void
}

const RpDealerButton: FC<TRpDealerButtonProps> = (props) => {
  const { text, cb, bg = 'green' } = props
  return (
    <Button
      bg={bg}
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()

        if (cb) cb()
      }}>
      {text}
    </Button>
  )
}

export default RpDealerButton
